import { render, staticRenderFns } from "./UpdateSingleTaskModal.vue?vue&type=template&id=b7974092&"
import script from "./UpdateSingleTaskModal.vue?vue&type=script&lang=js&"
export * from "./UpdateSingleTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports